<template>
	<div>
		<div class="mb-12">
			<p>Skriv inn koden du har mottatt på SMS</p>
			<v-form v-model="formIsValid" v-if="currentStep == '2'">
				<v-text-field v-model="form.smsCode" v-mask="mask" class="prime" placeholder="Skriv inn SMS-kode" :rules="rules.smsCode" autofocus />
			</v-form>
		</div>

		<v-btn color="primary" depressed @click="verifySMSCode(giftcard.mobile, form.smsCode, clientidentity, giftcard.giftcardNumber)" :disabled="!valid">Aktiver</v-btn>

		<div class="mt-5 text-faded" style="color: rgb(162, 162, 162); font-size: 0.8rem;">Les mer om <a href="/terms-of-use-portal">våre vilkår</a>.</div>
		<v-snackbar v-model="showSnackBar" :timeout="0" top absolute vertical>
			{{ snackBarText }}
			<br />
			<v-btn color="primary" @click="showSnackBar = false">Lukk</v-btn>
		</v-snackbar>
	</div>
</template>

<script>
import { UserService, GiftCardService } from '@/services';

export default {
	name: 'activate-giftcard-enter-sms-code',
	components: {},
	props: {
		giftcard: null,
		value: null // Current step,
	},
	data() {
		return {
			formIsValid: false,
			form: {
				smsCode: ''
			},
			mask: 'XXX',
			rules: {
				smsCode: [v => v.length == 3 || 'Ugylding SMS-kode. Lengde må være 3 tegn.']
			},
			clientidentity: null,
			showSnackBar: false,
			snackBarText: ''
		};
	},
	computed: {
		valid: function() {
			return this.formIsValid;
		},
		currentStep: {
			get() {
				return this.value || -1;
			},

			set(value) {
				this.$emit('input', value);
			}
		}
	},
	methods: {
		async sendSMSOneTimeCode(mobileNumber) {
			const clientidentity = await UserService.SendVerificationCode({
				mobile: mobileNumber
			});
			if (!clientidentity) {
				this.snackBarText = 'Klarte ikke sende sms, prøv igjen. Hvis det ikke fungerer kontakt kundesenter på https://fixit.no/bedrift/kontakt-oss/';
				this.showSnackBar = true;
			} else {
				this.clientidentity = clientidentity;
			}
		},
		async verifySMSCode(mobile, verificationCode, clientIdentity) {
			const verified = await UserService.VerifyCode({
				mobile,
				verificationCode,
				clientIdentity
			});

			if (verified) {
				const id = this.giftcard.giftcardNumber.replace(/ /g, '');
				const info = await this.ActivateGiftCard(id, mobile);
				if (typeof info == 'string') {
					this.snackBarText = `${info} Sjekk at du har skrevet riktig gavkortnummer i steg 1.`;
					this.showSnackBar = true;
				} else {
					this.$emit('update:giftcard', {
						...this.giftcard,
						...info
					});

					window.scrollTo({
						top: 0,
						left: 0,
						behavior: 'smooth'
					});

					this.currentStep++;
				}
			} else {
				this.snackBarText = 'Verifisering feilet. Se om du har skrevet inn riktig SMS-kode.';
				this.showSnackBar = true;
			}
		},
		async ActivateGiftCard(giftcardId, phoneNumber) {
			const info = await GiftCardService.ActivateGiftCard(giftcardId, phoneNumber);
			return info;
		}
	},
	watch: {
		currentStep: {
			handler(step) {
				if (step == 2) {
					this.sendSMSOneTimeCode(this.giftcard.mobile);
				}
			}
		},
		form: {
			deep: true,
			handler(form) {
				if (form.smsCode.length == 3) {
					this.verifySMSCode(this.giftcard.mobile, this.form.smsCode, this.clientidentity, this.giftcard.giftcardNumber);
				}

				if (form) {
					this.$emit('update:giftcard', {
						...form,
						...this.giftcard
					});
				}
			},
			immediate: true
		}
	}
};
</script>

<style lang="scss" scoped></style>
